<template>
  <div id="app">
    <div id="nav"><app-navbar></app-navbar></div>

    <transition name="routerAnim">
      <router-view />
    </transition>
  </div>
</template>
<script>
import Navbar from "./components/common/Navbar.vue";

export default {
  components: {
    "app-navbar": Navbar
  }
};
</script>
<style>
#app {
  font-size: 1.2rem;
  font-family: "Yanone Kaffeesatz", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}

html {
  background-color: darkgray;
}

#footer {
  position: relative;
  margin-top: 2%;
  padding-bottom: 1%;
  position: relative;
}
.routerAnim-enter-active,
.routerAnim-leave-active {
  transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}
.routerAnim-enter-active {
  transition-delay: 0.75s;
}

.routerAnim-enter,
.routerAnim-leave-to {
  opacity: 0;
}

.routerAnim-enter-to,
.routerAnim-leave {
  opacity: 1;
}
</style>
